import React from "react";
import NoDataFound from "../../common/NoDataFound";
import NextImage from "../../common/NextImage";
import { getImageUrl, teamLeagueInfoUrl, titleToSlug } from "../../../utils/generalLiveCenter";
// import "./FootballSquadTable.scss";

const FootballSquadTable = ({
  defender,
  websiteBaseUrl,
  dataPath,
  dataClient = false,
  sport = "football",
}) => {
  return (
    <div className="global_table striped squad_table">
      {defender?.length ? (
        <table>
          <thead>
            <tr>
              <th>Pos</th>
              <th>Player</th>
              <th>Apps</th>
              <th>Min</th>
              <th>Goals</th>
              <th>Asst</th>
            </tr>
          </thead>
          <tbody>
            <>
              {defender?.map((item, index) => (
                <tr key={item?.pid}>
                  <td>{index + 1}</td>
                  <td>
                    <div className="player_inf">
                      <div className="ply_avtar">
                        <NextImage
                          src={getImageUrl('', '', sport, item?.pid, 'player-pictures')}
                          width={24}
                          height={24}
                          alt="avtar"
                        />
                      </div>
                      <div className="ply_des">
                        <a
                          href={teamLeagueInfoUrl({
                            dataClient,
                            websiteBaseUrl,
                            dataPath,
                            category: "player",
                            sport,
                            name: titleToSlug(item?.nm),
                            id: item?.pid,
                          })}
                        >

                          <span className="name">{item?.nm}</span>
                        </a>
                        {item?.dob && (
                          <span className="sub_name">Dob: {item?.dob}</span>
                        )}
                      </div>
                    </div>
                  </td>
                  <td>{item?.apps}</td>
                  <td>{item?.min}</td>
                  <td>{item?.gos}</td>
                  <td>{item?.ast}</td>
                </tr>
              ))}
            </>
          </tbody>
        </table>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default FootballSquadTable;
